const quantityField = document.querySelector('.js-product-quantity-field');

if (quantityField) {
    const quantityMinus = document.querySelector('.js-product-quantity-minus');
    const quantityPlus = document.querySelector('.js-product-quantity-plus');

    quantityMinus.addEventListener('click', () => {
        let quantity = +quantityField.value;

        if (quantity > 1) {
            quantity--
        }

        quantityField.value = quantity;
        quantityField.dispatchEvent(new Event('change'));
    });

    quantityPlus.addEventListener('click', () => {
        let quantity = +quantityField.value;
        quantity++

        quantityField.value = quantity;
        quantityField.dispatchEvent(new Event('change'));
    });
}

const productForm = document.querySelector('.js-product-form');

if(productForm) {
    const productFormSubmitHandler = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'addToCart',
            eventModel: {
                product: {
                    id: +productForm.dataset.product,
                    price: +productForm.dataset.price / 100,
                    quantity: +(quantityField?.value || 1),
                    categories: productForm.dataset.categories.split(','),
                }
            }
        });
    };

    productForm.addEventListener('submit', productFormSubmitHandler);
}


const productSizeSelectors = [...document.querySelectorAll('.js-product-size-selector')];

if(productSizeSelectors) {
    
    productSizeSelectors.map(productSizeSelector => productSizeSelector.addEventListener('change', ()=> {
         const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('variant', productSizeSelector.value);
        window.location.search = urlParams;       
    }));

}


const readMoreLink = document.querySelector('.js-description-readmore-link');
const hiddenContent = document.querySelector('.js-description-hidden-content');

if (hiddenContent) {
    readMoreLink.addEventListener('click', ()=> {
        if(!hiddenContent.hasAttribute('data-open')) {
            hiddenContent.setAttribute('data-open', true)
            hiddenContent.style.height = `${hiddenContent.scrollHeight}px`;
        } else {
            hiddenContent.removeAttribute('data-open')
            hiddenContent.style.height = '20px';
        }
    })
}